/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * Exportní typ vrstvy.
 * @export
 * @enum {string}
 */

export const LayerTypeE = {
    WMS: 'wms',
    WMTS: 'wmts',
    MCWMTS: 'mcwmts',
    AGGREGATE: 'aggregate',
    USER_DB: 'user_db',
    GEOJSON: 'geojson',
    KML: 'kml'
} as const;

export type LayerTypeE = typeof LayerTypeE[keyof typeof LayerTypeE];



